<div class="min-h-screen bg-gray-50 flex flex-col">
  <div class="flex-1 px-4 sm:px-6 lg:px-8 py-4">
    <div class="max-w-7xl mx-auto flex flex-col gap-4">
      <!-- Page Header -->
      <div class="animate-slideInUp">
        <lib-feature-header
          [isLoading]="store.isLoading()"
          (closeClick)="onBackClick()"
          [title]="'Attendance Tracking'"
        >
          <!-- Sign In Status Filter -->
          <lib-sign-in-status-filter
            [status]="store.signInStatusFilter()"
            (filterChange)="onSignInStatusFilterChange($event)"
          />

          <!-- Stats Toggle Button -->
          <button
            class="inline-flex items-center justify-center py-2 px-2 rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
            [disabled]="store.isLoading()"
            (click)="onToggleStats()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 h-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
              />
            </svg>
          </button>

          <lib-refresh-button
            [disabled]="store.isLoading()"
            (refreshClick)="onRefresh()"
          />
        </lib-feature-header>
      </div>

      <!-- Error Message -->
      @if (store.error()) {
      <lib-error-alert (dismiss)="onClearError()" />
      }

      <!-- Statistics -->
      @if (isStatsVisible()) {
      <div class="animate-slideInUp" style="animation-delay: 100ms">
        <lib-attendance-stats [stats]="store.attendanceStats()" />
      </div>
      }

      <!-- Main Content Area -->
      <div
        class="flex flex-col sm:flex-row gap-6 animate-slideInUp"
        style="animation-delay: 200ms"
      >
        <!-- Left Panel - Alphabet Selector -->
        <div class="lg:w-28 xl:w-32 max-h-[calc(100vh-12rem)] overflow-y-auto">
          <lib-alphabet-selector
            [letters]="store.alphabetLetters()"
            [selectedLetter]="store.selectedLetter()"
            [isLoading]="store.isSubmitting()"
            (letterSelect)="onLetterSelect($any($event))"
          />
        </div>

        <!-- Right Panel - Expert List -->
        <div class="flex-1 flex flex-col">
          @if (store.selectedLetter()) {
          <div class="mb-4 flex-shrink-0">
            <h3 class="text-lg font-medium text-gray-900">
              Experts starting with "{{ store.selectedLetter() }}"
              <span class="text-sm font-normal text-gray-500 ml-2">
                ({{ store.selectedLetterCount() }} experts)
              </span>
            </h3>
          </div>
          } @if (store.filteredExperts().length > 0) {
          <div class="flex-1 max-h-[calc(100vh-12rem)] overflow-y-auto">
            <lib-expert-list
              [experts]="store.filteredExperts()"
              [selectedExpert]="store.selectedExpert()"
              [isSubmitting]="store.isSubmitting()"
              [canPerformAction]="store.canPerformAction()"
              (expertSelect)="onExpertSelect($any($event))"
              (signIn)="onSignIn($any($event))"
              (signOut)="onSignOut($any($event))"
            />
          </div>
          } @else if (!store.isLoading()) {
          <div class="text-center py-12">
            <shared-no-records-placeholder
              [title]="'No experts found'"
              [description]="'No experts found with selected criteria.'"
            />
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<lib-confirmation-dialog
  #confirmationDialog
  [confirmText]="getConfirmationAction()"
  cancelText="Cancel"
  (confirm)="confirmAction()"
  (dialogCancel)="cancelAction()"
/>
